import { Box, Button, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector, RootState } from "../../store";
import { useNavigate } from "react-router-dom";
import { getFormGroup, rmvMsgSccsFGr } from "../../store/feature/formGroup";

// icon
import AddIcon from "@mui/icons-material/Add";
import Toast from "../../components/atoms/toast";
import ListDataSkeleton from "../../components/template/skeleton/ListDataSkeleton";
import AdminPageAcccessSearch from "../../components/molecules/adminPageAccess/AdminPageAcccessSearch";
import AdminPageAcccessTable from "../../components/molecules/adminPageAccess/AdminPageAcccessTable";
import { getAdminPageAccessList } from "../../store/feature/adminPageAccess";
import { getAdminRolesList } from "../../store/feature/adminRoles";
import { removeDataAdmPageMaster } from "../../store/feature/adminPageMaster";

const AdminPageAccess = () => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [params, setParams] = useState<object>({});
  const [defaultValue, setDefaultValue] = useState({});

  const { admPageAccess } = useAppSelector((state: RootState) => state.user);
  const { isLoadingAdmPageAccess, isLoadingEvent } = useAppSelector(
    (state: RootState) => state.admPageAcs
  );
  const { dataFGroup, msgSccsFGr } = useAppSelector(
    (state: RootState) => state.fGroup
  );

  const handleCloseToast = () => {
    dispatch(rmvMsgSccsFGr());
  };

  useEffect(() => {
    if (Object.keys(admPageAccess).length) {
      dispatch(getAdminRolesList(params));
    }
  }, [params, admPageAccess]);

  const handleCreate = () => {
    dispatch(removeDataAdmPageMaster());
    navigate("/admin-page-access/create");
  };

  return (
    <ListDataSkeleton
      isLoading={isLoadingAdmPageAccess}
      isLoadingEvent={isLoadingEvent}
      titleWidth={"300"}
    >
      <Box>
        <Typography
          variant="h3"
          fontFamily="Open Sans"
          sx={{ marginY: "20px" }}
        >
          Admin Page Access
        </Typography>

        {admPageAccess.uc_adm_pge_acs_create === 1 && (
          <Box sx={{ display: "flex", flexDirection: "row-reverse" }}>
            <Button
              variant="contained"
              color="primary"
              onClick={handleCreate}
              sx={{ marginBottom: "18px" }}
            >
              <AddIcon /> Create
            </Button>
          </Box>
        )}
        <AdminPageAcccessSearch params={params} setParams={setParams} />
        <AdminPageAcccessTable
          data={dataFGroup}
          params={params}
          setParams={setParams}
          defaultValue={defaultValue}
          setDefaultValue={setDefaultValue}
        />
        <Toast
          severity="success"
          open={msgSccsFGr !== ""}
          handleClose={handleCloseToast}
          message={msgSccsFGr}
        />
      </Box>
    </ListDataSkeleton>
  );
};

export default AdminPageAccess;
